<div
  class="expandable"
  [class.expandable--expanded]="textExpanded"
  [class.expandable--overflowing]="textOverflowing"
  [style]="backgroundColor ? '--expandable-background-color: ' + backgroundColor + ';' : ''">
  @if (text) {
  <div class="expandable__hidden" [innerHtml]="text" #referenceElement></div>
  } @if (text) {
  <div class="expandable__hidden expandable__hidden--collapsed" [innerHtml]="text" #textElement></div>
  } @if (text) {
  <div class="expandable__content" [ngStyle]="{ 'max-height.px': maxHeight }" [innerHtml]="text"></div>
  } @if (textOverflowing) {
  <button class="expandable__button mat-body-2" (click)="toggle()">
    @if (!textExpanded) {
    <ng-container i18n="@@uiElements-expandableText-more">+ Alles anzeigen</ng-container>
    } @else {
    <ng-container i18n="@@uiElements-expandableText-less">- Weniger anzeigen</ng-container>
    }
  </button>
  }
</div>
